import { PaperPlaneTiltIcon } from '@phosphor-icons/react';
import i18n from 'i18next';

import { Button, Chip, Text } from '@components';
import { CellType, Dictionaries, VariantType } from '@enums';
import type { Column } from '@types';
import { getCodeValueFromCatalog, getColumnSizes, validateValueEqual } from '@utils';

export const getWsConfigMemberColumns = ({ handleStatus, isOwner }): Column[] => {
  return [
    {
      label: i18n.t('configuration:tables.id'),
      value: 'id',
      ...getColumnSizes(50),
    },
    {
      label: i18n.t('configuration:tables.name'),
      value: 'name',
      ...getColumnSizes(200),
      format: (value, fullData) => (
        <div className="flex space-x-3 items-center">
          <Text $level={4} color="text-black" className="truncate">
            {value}
          </Text>
          <Text $level={6} color="text-gray-400" className="truncate font-light">
            {`@${fullData?.email}`}
          </Text>
        </div>
      ),
    },
    {
      label: i18n.t('configuration:tables.accessLevel'),
      value: 'permission',
      cellType: CellType.Custom,
      format: (value, row) => (
        <Text $level={5} $customizeColor className="truncate">
          {getCodeValueFromCatalog(Dictionaries.Roles, value)}
        </Text>
      ),
      ...getColumnSizes(90),
    },
    {
      label: i18n.t('configuration:tables.status'),
      value: 'status',
      cellType: CellType.Custom,
      format: (value, fullData) => (
        <div className="flex gap-2 items-center">
          <Chip
            color={
              validateValueEqual(value, 'pending') ? 'amber' : validateValueEqual(value, 'active') ? 'green' : 'red'
            }
            className="self-start px-2.5 py-1 ellipsis-text rounded-md font-medium"
            adornment={
              <Text $level={5} $customizeColor className="truncate">
                {getCodeValueFromCatalog(Dictionaries.WorkspaceMemberStatus, value)}
              </Text>
            }
          />
          {!!validateValueEqual(value, 'pending') && isOwner && (
            <Button
              hoverEffect
              hint={
                <Text color="text-white" $level={6}>
                  {i18n.t('common:button.resendInvitation')}
                </Text>
              }
              variant={VariantType.Clean}
              className="-my-0.5 p-1.5 rounded-md enabled:shadow-none"
              onClick={() => handleStatus(fullData)}
              adornment={<PaperPlaneTiltIcon weight="bold" className="size-4 text-blue-400" />}
            />
          )}
        </div>
      ),
      ...getColumnSizes(90),
    },
    {
      label: i18n.t('configuration:tables.action'),
      value: 'actions',
      cellType: CellType.Action,
      ...getColumnSizes(60),
    },
  ];
};
